import { Alert as ReactAlert } from '@a-ui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { DetailLayout } from '../../../components/DetailLayout';
import LayoutTile from '../../../components/LayoutTile';
import Typography from '../../../components/Typography';
import { api } from '../../../hooks/api.hooks';
import { translate } from '../../../i18n';
import { ITranslations } from '../../../i18n/config';
import { useAuthentication } from '../../../state/Authentication';
import { useMessage } from '../../../state/Message';
import { setMessage } from '../../../state/Message/actions';

interface PhoneDetailProps {}

const PhoneDetail: React.FC<PhoneDetailProps> = () => {
  const [isModalVisible, setModalVisible] = React.useState(false);
  const [error, setError] = React.useState<ITranslations>();
  const {
    state: { user, eID },
  } = useAuthentication();
  const { dispatch: dispatchMessage } = useMessage();
  const history = useHistory();

  React.useEffect(() => {
    if (user.phonePrimary) return;

    history.replace('/gegevens/aanmeldsleutels/telefoon/toevoegen');
  }, [user]);

  React.useEffect(() => {
    if (!user.phone?.candidate) return;

    if (user.phonePrimary) {
      history.replace('/gegevens/aanmeldsleutels/telefoon/wijzigen');
    }

    history.replace('/gegevens/aanmeldsleutels/telefoon/toevoegen');
  }, [user]);

  const canRemoveKey = React.useMemo(() => {
    if (user.emailPrimary || eID?.rrnr) return true;

    return false;
  }, [user]);

  const toggleModal = () => {
    setModalVisible(!isModalVisible);
  };

  const handleDelete = async () => {
    try {
      await api.delete('/access-keys/phone');
      dispatchMessage(
        setMessage('accessKeys.phone.delete.success', 'accessKeysOverview', 'success'),
      );
      history.push('/gegevens');
    } catch (e) {
      setError('error.server.unknown');
      setModalVisible(false);
    }
  };

  return (
    <DetailLayout
      backAction="/gegevens"
      backLabel="accessKeys.overview.title"
      title="accessKeys.phone.title"
      description="accessKeys.phone.intro"
    >
      {error && (
        <div className="u-margin-bottom">
          <ReactAlert theme="danger">
            <Typography>{translate(error)}</Typography>
          </ReactAlert>
        </div>
      )}

      <LayoutTile
        label={translate('accessKeys.phone.update')}
        to="/gegevens/aanmeldsleutels/telefoon/wijzigen"
        toLabel={translate('accessKeys.phone.update')}
        value={user.phonePrimary}
      />

      <LayoutTile
        label={translate('common.button.delete')}
        toLabel={translate('common.button.delete')}
        description={translate('accessKeys.phone.delete')}
        disabled={!canRemoveKey}
        onClick={toggleModal}
        variant="danger"
        classNames="u-margin-top-xs"
      />

      {!canRemoveKey && (
        <Typography classNames="u-text-light u-margin-top-xs">
          {translate('accessKeys.phone.delete.prohibited')}
        </Typography>
      )}

      <ConfirmationModal
        isOpen={isModalVisible}
        title="accessKeys.phone.delete.modal.title"
        body="accessKeys.phone.delete.modal.description"
        confirmLabel="accessKeys.phone.delete.modal.confirm"
        cancelLabel="common.modal.cancel"
        variant="danger"
        onConfirm={handleDelete}
        onRequestClose={toggleModal}
      />
    </DetailLayout>
  );
};

export default PhoneDetail;
